module.exports = {
  BROWSER_STATE: '__OTEL_BROWSER_STATE__',
  IGNORE_URLS: [/(https?:\/\/bam\.nr-data\.net\/?).*$/],
  DISTRIBUTED_TRACING: 'distributed-tracing',
};
